<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import _log from '@/helpers/log';

@Component
export default class ComponentMixin extends Vue {

  /**
   * Pour un log de rendering (mounted et updated) d'un composant, ajoutez son nom au tableau.
   */
  protected get logRenders(): boolean {
    return !![
      // 'DatedDataTable',
      // 'ScenarioPVEditor',
      // 'PV'
    ].find(name => this.componentName === name);
  }

  protected get componentName(): string {
    return this.$options.name || 'unnamed';
  }

  public mounted() {
    if (this.logRenders) {
      // this can be used to check when a component rerenders.
      _log.log('mounted', this.componentName);
    }
  }

  public updated() {
    if (this.logRenders) {
      // this can be used to check when a component rerenders.
      _log.log('updated', this.componentName);
    }
  }
}

</script>

<style></style>
